import {
  validateSOPQInfantsCountSchema,
  validateTripTypeSchema,
  validateCabinClass,
  validateProductTypeSchema,
  validateAdultsCountSchema,
  validateYouthCountSchema,
  validateChildrenCountSchema,
  validateDepartureAirport,
  validateArrivalAirport,
  validateCalendarSchema,
  getValidationErrors
} from './validators'

export const validateSOPQFlightsSchema = values => {
  const schemas = {
    tripType: values => validateTripTypeSchema(values),
    cabinClass: values => validateCabinClass(values),
    productType: values => validateProductTypeSchema(values),
    adultsCount: values => validateAdultsCountSchema(values),
    youthsCount: values => validateYouthCountSchema(values),
    childrenCount: values => validateChildrenCountSchema(values),
    infantsCount: values => validateSOPQInfantsCountSchema(values),
    departureAirport: values => validateDepartureAirport(values),
    arrivalAirport: values => validateArrivalAirport(values),
    departureDate: values => validateCalendarSchema(values, 'departureDate'),
    arrivalDate: values => validateCalendarSchema(values, 'arrivalDate')
  }

  return schemas
}

export const validateSOPQFlightsSchemaWithErrors = values => {
  const schemas = validateSOPQFlightsSchema(values)
  return getValidationErrors(schemas, values)
}
